export default {
  rating: {
    en: `Average rating: {ratingValue} ({ratingCount} ratings), {reviewCount} reviews`,
  },
}
